import React from 'react'
import { withStyles } from '@material-ui/core'
import styles from '../styles'
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
} from '@material-ui/core'
import { styled } from '@material-ui/core'
import { AccordionSummaryContent } from '..'
import UserType from 'src/model/user-types'
import { useSelector } from 'react-redux'
import { CoreButton } from 'src/components/core'
import { useParams, useHistory } from 'react-router-dom'
import { Icon } from '@iconify/react'
const StyledAccordion = styled(Accordion)(({ theme }) => ({
  width: '100%',
  '&.Mui-expanded': {
    boxShadow: 'none',
  },
}))
const OptIn = props => {
  const { accessRule, handleAccessRule, classes } = props
  const userControl = UserType[window.CONSTANTS.USER_ROLE_ID]
  const { id } = useParams()
  const history = useHistory()
  const doubleOptinControl = () => {
    if (
      userControl == 'Basic' ||
      userControl == 'Starter - Legacy' ||
      userControl == 'Starter' ||
      userControl == 'Starter A'
    ) {
      return true
    }
    return false
  }
  const [anchorEl, setAnchorEl] = React.useState(null)

  const handleClick = event => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const open = Boolean(anchorEl)
  const idz = open ? 'simple-popover' : undefined

  const handleClickSwitch = event => {
    doubleOptinControl() ? handleClick(event) : handleAccessRule(1)
  }

  const onClickLearners = () => {
    history.push(`/collection/${id}/learners`)
  }

  return (
    <div className={classes.root}>
      <StyledAccordion expanded={accessRule == 1}>
        <AccordionSummary
          className={classes.accordion__summary}
          aria-controls="panel1bh-content"
          id="panel1bh-header"
        >
          <AccordionSummaryContent
            accessRule={accessRule}
            handleClickSwitch={handleClickSwitch}
            contentHeader={'Email verification'}
            contentDescription={'Grant access after email entry'}
            id={idz}
            badgeType={1}
            open={open}
            anchorEl={anchorEl}
            handleClose={handleClose}
            popupHeader={'Upgrade to Pro'}
            popupContent={
              'Upon entering their email address at the sign-up wall of your course, learners receive a link to proceed.'
            }
            accessRuleEqual={1}
          />
        </AccordionSummary>
        <AccordionDetails className={classes.accordion__details}>
          <div className={classes.accordion__details__content}>
            <CoreButton
              size="small"
              onClick={() => {
                onClickLearners()
              }}
            >
              List collected emails
            </CoreButton>
          </div>
        </AccordionDetails>
      </StyledAccordion>
    </div>
  )
}

export default withStyles(styles)(OptIn)
